var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNonfulfiledTrips(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 104.952,
    height: 116.126,
    viewBox: "0 0 104.952 116.126",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "nonfulfiled_trips",
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10124",
    "data-name": "Group 10124",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_12009",
    "data-name": "Path 12009",
    d: "M95.718,57.979c0-4.642-2.17-8.124-6.105-10.6A3.361,3.361,0,0,1,88.2,45.668c-1.968-6.206-3.835-12.514-5.651-18.77A24.845,24.845,0,0,1,61.508,4.343a7.274,7.274,0,0,0-2.17-.3H36.431c-4.037,0-6.509,2.422-6.509,6.509V16H26.036c-6.257,0-10.546,3.28-12.312,9.284-2.018,6.862-4.087,13.674-6.206,20.536a2.4,2.4,0,0,1-1.11,1.413A12.142,12.142,0,0,0,0,58.433V81.139a7.37,7.37,0,0,0,.151,1.816C.807,86.034,2.927,87.5,6,87.9c0,1.968-.05,3.936,0,5.853a5.944,5.944,0,0,0,5.954,6c1.716.05,3.431,0,5.1,0,4.592,0,6.862-2.321,6.913-6.913v-5H71.8v5.9a5.987,5.987,0,0,0,6,6c1.867.05,3.784,0,5.651,0a6.012,6.012,0,0,0,6.307-6.307V88c4.743-1.261,6-2.876,6-7.72,0-7.417,0-14.885-.05-22.3ZM23.412,34.517c.555-1.766,1.211-3.482,1.615-5.3.252-1.06.706-1.261,1.716-1.261H69.077c.959,0,1.362.2,1.615,1.211,1.615,5.5,3.33,11,5.046,16.7H20.082Q21.747,40.117,23.412,34.517Zm.5,38.3a5.976,5.976,0,0,1-5.954-6,5.9,5.9,0,0,1,6-5.9,5.954,5.954,0,1,1-.05,11.908Zm47.834,0a5.955,5.955,0,1,1,6.055-5.9A6.009,6.009,0,0,1,71.751,72.814Z",
    transform: "translate(0 16.345)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12010",
    "data-name": "Path 12010",
    d: "M32.039,0A18.638,18.638,0,0,0,13.42,18.619a18.385,18.385,0,0,0,7.165,14.633,15.692,15.692,0,0,0,3.482,2.22,19.018,19.018,0,0,0,7.972,1.766A18.619,18.619,0,1,0,32.039,0Zm8.275,23.917-2.977,2.977-5.3-5.3-5.349,5.3-2.977-2.977,5.349-5.3-5.3-5.3,2.977-2.977,5.3,5.3,5.3-5.3,2.977,2.977-5.3,5.3,5.3,5.3Z",
    transform: "translate(54.294)",
    fill: "#fff"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNonfulfiledTrips);
export default __webpack_public_path__ + "static/media/nonfulfiled_trips.ca8e594494430ed255b9d6464ea4eb5f.svg";
export { ForwardRef as ReactComponent };